export default {
    exportBehavior_fileFormat: "Formato de archivo",
    exportBehavior_reportType: "Tipo de Reporte",
    exportBehavior_simpleReport: "Reporte Simple",
    exportBehavior_detailedReport: "Reporte Detallado",
    exportBehavior_exportBehavior: "Exportar Comportamiento",
    exportBehavior_exportGenerated : "Se está generando la exportación....",
}
